import Container from './Container';
export type { ContainerProps } from './Container.types';

export default Container;
